import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const WrittenReviewCard = ({ review }) => (
  <article className="card-3d flex h-full flex-col p-6">
    <Icon name="Quote" size={22} className="text-royal-gold/50" />

    <p className="mt-4 flex-1 text-sm leading-relaxed text-white/65">“{review?.quote}”</p>

    <div className="mt-5 flex items-center gap-3 border-t border-white/8 pt-5">
      <Image src={review?.avatar} alt={review?.name} className="h-11 w-11 rounded-full" />
      <div className="min-w-0 flex-1">
        <div className="truncate font-display text-sm font-semibold text-white">{review?.name}</div>
        <div className="truncate text-xs text-white/45">{review?.location} · {review?.game}</div>
      </div>
      <div className="text-right">
        <div className="font-display text-sm font-bold text-wa-green">{review?.winAmount}</div>
        <div className="flex justify-end">
          {Array.from({ length: review?.rating ?? 5 }).map((_, i) => (
            <Icon key={i} name="Star" size={11} color="#F0C24B" fill="#F0C24B" />
          ))}
        </div>
      </div>
    </div>
  </article>
);

export default WrittenReviewCard;
